import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';

import { animated, useTransition } from 'react-spring';
import VisuallyHidden from '@reach/visually-hidden';

import DialogButton from '../dialogButton';
import { MenuIcon } from '../icons';

const Header = ({ navLinks, siteTitle }) => {
    const navBreakpoint = 1200;
    const [navExpanded, setNavExpanded] = useState(
        (typeof window !== 'undefined' ? window.innerWidth : 0) > navBreakpoint
    );
    const [headerShadow, setHeaderShadow] = useState(true);
    const headerRef = useRef(null);

    useEffect(() => {
        // Because of the empty dependency array passed as the second
        // argument to `useEffect()`, this is effectively a `componentDidMount()`
        window.addEventListener('resize', handleWindowResize);

        // The `return` statement here is effectively a `componentWillDismount()`
        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);

    const handleWindowResize = () => {
        setNavExpanded(
            (typeof window !== 'undefined' ? window.innerWidth : 0) >
                navBreakpoint
        );
    };

    // const [rafExecuting, setRafExecuting] = useState(false);
    // const [isSticky, setSticky] = useState(true);

    /**
     * The parallax styling prevents the onScroll event from firing.
     * It has something to do with the `perspective: 2px;` property.
     */
    // const calculateStickyState = useCallback(() => {
    //   console.log('calculate')
    //   if (rafExecuting) {
    //     return;
    //   }

    //   setRafExecuting(true);

    //   requestAnimationFrame(() => {
    //     const pastStickyThreshold = headerRef && window.scrollY > 0;

    //     if (pastStickyThreshold && !isSticky) {
    //       setSticky(true);
    //     } else if (!pastStickyThreshold && isSticky) {
    //       setSticky(false);
    //     }

    //     setRafExecuting(false);
    //   });
    // }, [isSticky, rafExecuting]);

    // useLayoutEffect(() => {
    //   console.log('layoutEffect')
    //   const handleResize = () => {
    //     setNavExpanded(window.innerWidth > navBreakpoint);
    //   }

    //   window.addEventListener("scroll", calculateStickyState);
    //   window.addEventListener('resize', handleResize);

    //   // cleanup
    //   return () => {
    //     window.removeEventListener("resize", () => handleResize);
    //     window.removeEventListener('scroll', () => calculateStickyState);
    //   };
    // }, [calculateStickyState]);

    function toggleNavExpanded(event) {
        event.preventDefault();
        setNavExpanded(!navExpanded);

        // When expanding the navigation, hide the header shadow
        // because navigation shadow will take over while it is expanded.
        if (!navExpanded) {
            setHeaderShadow(false);
        }
    }

    const transitions = useTransition(navExpanded, null, {
        from: { opacity: 1, transform: 'translate3d(0px, -100%, 0px)' },
        enter: { opacity: 1, transform: 'translate3d(0px, 0%, 0px)' },
        leave: { opacity: 1, transform: 'translate3d(0px, -100%, 0px)' },
        onDestroyed() {
            // When animation is finished, check if navigation is expanded.
            // If not, then set the header to take over the box shadow.
            if (!navExpanded) {
                setHeaderShadow(true);
            }
        },
    });

    return (
        <header
            className={`main-header${headerShadow ? ' header-shadow' : ''}`}
            ref={headerRef}
        >
            <div className="background-for-animation"></div>
            <Link className="logo-container" to="/">
                <VisuallyHidden>{siteTitle}</VisuallyHidden>
                <img
                    alt=""
                    className="weave-logo"
                    src="https://storage.googleapis.com/weave-dev/images/logo-color-side.svg"
                />
            </Link>

            {transitions.map(
                ({ item, key, props: styles }) =>
                    item && (
                        <animated.nav key={key} style={styles}>
                            {navLinks.map(link => (
                                <Link
                                    activeClassName="nav-active"
                                    className="nav-link"
                                    key={link.name}
                                    // https://www.gatsbyjs.org/docs/gatsby-link/#show-active-styles-for-partially-matched-and-parent-links
                                    partiallyActive={true}
                                    to={link.route}
                                >
                                    {link.name}
                                </Link>
                            ))}
                        </animated.nav>
                    )
            )}

            <DialogButton analyticsValue={1} className="call-to-action">
                Talk to Us
            </DialogButton>
            <button
                className="icon menu"
                onClick={toggleNavExpanded}
                type="button"
            >
                <VisuallyHidden>menu</VisuallyHidden>
                <MenuIcon />
            </button>
            <div
                className={
                    navExpanded ? 'nav-clickaway-active' : 'nav-clickaway'
                }
                onClick={toggleNavExpanded}
            />
        </header>
    );
};

Header.defaultProps = {
    siteTitle: `Weave`,
};

Header.propTypes = {
    navLinks: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string,
            route: PropTypes.string,
        })
    ),
    siteTitle: PropTypes.string,
};

export default Header;
